import styled from 'styled-components';

export const FileInput = styled.input.attrs({ type: 'file', accept: '.pdf' })`
  display: none;
  cursor: pointer;
`;

export const StyledButtonUpload = styled.button`
  background-color: #87CEFA; /* LightSkyBlue */
  border-radius: 100px;
  box-shadow: 
    rgba(135, 206, 250, 0.2) 0 -25px 18px -14px inset,
    rgba(135, 206, 250, 0.15) 0 1px 2px,
    rgba(135, 206, 250, 0.15) 0 2px 4px,
    rgba(135, 206, 250, 0.15) 0 4px 8px,
    rgba(135, 206, 250, 0.15) 0 8px 16px,
    rgba(135, 206, 250, 0.15) 0 16px 32px;
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 3px;
  width: 55px;
  height: 20px;

  :hover {
    box-shadow: 
      rgba(135, 206, 250, 0.35) 0 -25px 18px -14px inset,
      rgba(135, 206, 250, 0.35) 0 1px 2px,
      rgba(135, 206, 250, 0.35) 0 2px 4px,
      rgba(135, 206, 250, 0.35) 0 4px 8px,
      rgba(135, 206, 250, 0.35) 0 8px 16px,
      rgba(135, 206, 250, 0.35) 0 16px 32px;
    transform: scale(1.02);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

//style componente da parte de merge
export const StyledButtonMerge = styled.button`
  background-color: #87CEFA; /* LightSkyBlue */
  border-radius: 100px;
  box-shadow: 
    rgba(135, 206, 250, 0.2) 0 -25px 18px -14px inset,
    rgba(135, 206, 250, 0.15) 0 1px 2px,
    rgba(135, 206, 250, 0.15) 0 2px 4px,
    rgba(135, 206, 250, 0.15) 0 4px 8px,
    rgba(135, 206, 250, 0.15) 0 8px 16px,
    rgba(135, 206, 250, 0.15) 0 16px 32px;
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 3px;
  width: 55px;
  height: 20px;

  :hover {
    box-shadow: 
      rgba(135, 206, 250, 0.35) 0 -25px 18px -14px inset,
      rgba(135, 206, 250, 0.35) 0 1px 2px,
      rgba(135, 206, 250, 0.35) 0 2px 4px,
      rgba(135, 206, 250, 0.35) 0 4px 8px,
      rgba(135, 206, 250, 0.35) 0 8px 16px,
      rgba(135, 206, 250, 0.35) 0 16px 32px;
    transform: scale(1.02);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const StyledButtonMergeCancel = styled.button`
  background-color: #FFA07A;
  border-radius: 100px;
  box-shadow:
    rgba(255, 160, 122, 0.2) 0 -25px 18px -14px inset,
    rgba(255, 160, 122, 0.15) 0 1px 2px,
    rgba(255, 160, 122, 0.15) 0 2px 4px,
    rgba(255, 160, 122, 0.15) 0 4px 8px,
    rgba(255, 160, 122, 0.15) 0 8px 16px,
    rgba(255, 160, 122, 0.15) 0 16px 32px;
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 3px;
  width: 55px;
  height: 20px;

  &:hover:not(:disabled) {
    box-shadow:
      rgba(255, 160, 122, 0.35) 0 -25px 18px -14px inset,
      rgba(255, 160, 122, 0.35) 0 1px 2px,
      rgba(255, 160, 122, 0.35) 0 2px 4px,
      rgba(255, 160, 122, 0.35) 0 4px 8px,
      rgba(255, 160, 122, 0.35) 0 8px 16px,
      rgba(255, 160, 122, 0.35) 0 16px 32px;
    transform: scale(1.02);
  }

  &:disabled {
    background-color: var(--border-default); /* cinza quando desabilitado */
    color: var(--text-muted);
    cursor: not-allowed;
    box-shadow: none; /* remove sombra hover */
    transform: none;  /* remove efeito de escala */
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const StyledButtonDownload = styled.button`
  background-color: #7CFCB8;
  border-radius: 100px;
  box-shadow: 
    rgba(124, 252, 184, 0.2) 0 -25px 18px -14px inset,
    rgba(124, 252, 184, 0.15) 0 1px 2px,
    rgba(124, 252, 184, 0.15) 0 2px 4px,
    rgba(124, 252, 184, 0.15) 0 4px 8px,
    rgba(124, 252, 184, 0.15) 0 8px 16px,
    rgba(124, 252, 184, 0.15) 0 16px 32px;

  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 0px;
  width: 55px;
  height: 20px;

  :hover:not(:disabled) {
    box-shadow: 
      rgba(124, 252, 184, 0.35) 0 -25px 18px -14px inset,
      rgba(124, 252, 184, 0.35) 0 1px 2px,
      rgba(124, 252, 184, 0.35) 0 2px 4px,
      rgba(124, 252, 184, 0.35) 0 4px 8px,
      rgba(124, 252, 184, 0.35) 0 8px 16px,
      rgba(124, 252, 184, 0.35) 0 16px 32px;
    transform: scale(1.02);
  }

  /* 🔥 ESTADO DESABILITADO */
  :disabled {
    opacity: 0.4;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const StyledButtonLogs = styled.button`
  background-color: #D8BFD8; /* Lavanda claro */
  border-radius: 100px;
  box-shadow: 
    rgba(216, 191, 216, 0.2) 0 -25px 18px -14px inset,
    rgba(216, 191, 216, 0.15) 0 1px 2px,
    rgba(216, 191, 216, 0.15) 0 2px 4px,
    rgba(216, 191, 216, 0.15) 0 4px 8px,
    rgba(216, 191, 216, 0.15) 0 8px 16px,
    rgba(216, 191, 216, 0.15) 0 16px 32px;

  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 0px;
  width: 55px;
  height: 20px;

  :hover {
    box-shadow: 
      rgba(216, 191, 216, 0.35) 0 -25px 18px -14px inset,
      rgba(216, 191, 216, 0.35) 0 1px 2px,
      rgba(216, 191, 216, 0.35) 0 2px 4px,
      rgba(216, 191, 216, 0.35) 0 4px 8px,
      rgba(216, 191, 216, 0.35) 0 8px 16px,
      rgba(216, 191, 216, 0.35) 0 16px 32px;
    transform: scale(1.02);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;

export const StyledButtonShowNft = styled.button`
  background-color: var(--accent-secondary);
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  color: var(--text-on-accent);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 3px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 10px;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  margin-left: 0px;
  width: 55px;
  height: 20px;

  :hover {
    box-shadow: var(--shadow-md);
    transform: scale(1.02);
  }

  @media screen and (max-width: 768px) {
    font-size: 10px;
  }
`;


